export default {
	canMakePayment($ctrl) {
		return !$ctrl.$session.isSalesManagementMode() && $ctrl.mode !== "creditmemo";
	},

	canRequestReturn($ctrl) {
		return !$ctrl.$session.isSalesManagementMode() && $ctrl.mode !== "creditmemo";
	},
	canReturn: (invoice) => false,
	lineOrderBy: "position",
	lineSearch: "",
	hideContactUs: false,
	lineSortOptions: {
		position: "Position: Low to High",
		"-position": "Position: High to Low",
		description: "Description: A to Z",
		price: "Price: Low to High",
		"-price": "Price: High to Low",
		qtyShipped: "Qty Shipped: Low to High",
		"-qtyShipped": "Qty Shipped: High to Low",
		qtyOrdered: "Qty Ordered: Low to High",
		"-qtyOrdered": "Qty Ordered: High to Low",
		productId: "Item #: Low to High",
	},
	hideTotals: true,
	reasonCodes: ["Processing", "Refused", "Quality"],
	ShowViewRequestHistory: true,
	//invoiceFields: "Id,InvoiceDate,DueDate,Status,SalesRepId,TransactionType,PONumber,OrderNumber,RetailerId,Custom1,CompanyName,Division,InvoiceTotal,TotalFreight,TotalShipped,InvoiceBalance,RetailerEmail,RetailerId,CompanyName",
	invoiceFields: "Id,InvoiceDate,RetailerId,ShipId,DueDate,Status,InvoiceTotal,CreditMemoTotal,SalesRepId,PaymentTermsId,CompanyName,TransactionType,PONumber,OrderNumber,Division,TagFor,Reason,Description,RetailerEmail,SalesRepName,InvoiceBalance",
	invoiceOrderBy: "-InvoiceDate,-Id",
	hideInvoiceActions: false,
	hideInvoiceCreditRequest: false,
	hideInvoiceMakePayment: false,
	allowPartialPayments: false,
	allowCreditsInPayment: true,
	showBulkActions: false,
	hideLeftNavFilters: true
};
